import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const Field = ({ id, label, hint, ...props }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={`${id}-input`} className="bg-[#0F141C]" {...props} />
    {hint && <p className="text-xs text-slate-600">{hint}</p>}
  </div>
);
